import { modifier } from "ember-modifier"
import { createFocusTrap, type Options } from "focus-trap"

export default modifier(function focusTrap(
  element: HTMLElement,
  _params,
  { focusTrapOptions }: { focusTrapOptions?: Options } = {}
) {
  let trap = createFocusTrap(element, focusTrapOptions)
  trap.activate()

  return () => {
    trap.deactivate()
  }
})
